import { Container, Row, Col } from 'react-bootstrap';
import ComicCard from '../../components/ComicCard/ComicCard';

const ComicList = ({ comics }) => {
  return (
    <Container>
      <Row className="g-4">
        {comics.map(comic => (
          <Col key={comic.book_id} sm={6} md={4} lg={3} className="d-flex align-items-stretch">
            <ComicCard comic={comic} />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default ComicList;
